import React from "react";

const EmployeeFeedbackSummaryCard = ({
  submitted = 0,
  notSubmitted = 0,
  onFeedbackClick,
}) => {
  const total = submitted + notSubmitted;

  const completionRate =
    total > 0 ? Math.round((submitted / total) * 100) : 0;

  return (
    <div className="w-[95%] xl:w-1/3 bg-[#6366F1] rounded-3xl p-7 flex flex-col gap-6 shadow-lg">
      
      {/* Header */}
      <div className="flex items-center gap-4">
        <img
          src="/Assets/dashboard-1.png"
          alt="Employee Feedback"
          className="w-11 h-11"
        />
        <div>
          <p className="text-white text-sm font-medium">
            Employee Feedback Overview
          </p>
          <p className="text-white text-2xl font-bold">
            {total} Bookings
          </p>
        </div>
      </div>

      <div className="w-full h-[1px] bg-white/30" />

      {/* Submitted */}
      <div
        onClick={() => onFeedbackClick?.("SUBMITTED")}
        className="cursor-pointer bg-white rounded-xl p-4 flex justify-between items-center hover:scale-105 transition"
      >
        <div>
          <p className="text-green-600 text-sm font-semibold">
            Submitted
          </p>
          <p className="text-xs text-gray-500">
            Feedback completed
          </p>
        </div>
        <p className="text-[#39354E] font-bold text-lg">
          {submitted}
        </p>
      </div>

      {/* Not Submitted */}
      <div
        onClick={() => onFeedbackClick?.("NOT_SUBMITTED")}
        className="cursor-pointer bg-white/90 rounded-xl p-4 flex justify-between items-center hover:scale-105 transition"
      >
        <div>
          <p className="text-red-600 text-sm font-semibold">
            Not Submitted
          </p>
          <p className="text-xs text-gray-500">
            Pending feedback
          </p>
        </div>
        <p className="text-[#39354E] font-bold text-lg">
          {notSubmitted}
        </p>
      </div>

      <div className="w-full h-[1px] bg-white/30" />

      {/* Completion Rate */}
      <div className="bg-[#1E1B4B] rounded-xl p-4 flex justify-between items-center">
        <div>
          <p className="text-white text-sm font-semibold">
            Completion Rate
          </p>
          <p className="text-xs text-white/70">
            Submitted / Total Bookings
          </p>
        </div>
        <p className="text-white font-bold text-lg">
          {completionRate}%
        </p>
      </div>
    </div>
  );
};

export default EmployeeFeedbackSummaryCard;